if (typeof FormToggle !== 'function') {
	class FormToggle extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				buttons: '.form-toggle__buttons > button',
				forms: '.form-toggle__content > div',
			};

			this.classes = {
				active: 'btn--primary',
				inactive: 'btn--secondary',
				activeForm: 'active',
			};

			this.buttons = this.querySelectorAll(this.selectors.buttons);
			this.forms = document.querySelectorAll(this.selectors.forms);

			this.init();
		}

		init() {
			this.addEventListeners();
		}

		addEventListeners() {
			const { buttons } = this;

			buttons.forEach((button) => {
				button.addEventListener('click', () => {
					const formId = button.getAttribute('data-target');
					const form = document.getElementById(formId);

					if (form) {
						this.setActiveForm(form);
						this.setActiveButton(button);
					}
				});
			});
		}

		setActiveForm(currentForm) {
			const { forms, classes } = this;

			forms.forEach((form) => {
				form.classList.remove(classes.activeForm);
			});

			currentForm.classList.add(classes.activeForm);
		}

		setActiveButton(currentButton) {
			const { buttons, classes } = this;

			buttons.forEach((button) => {
				button.classList.remove(classes.active);
				button.classList.add(classes.inactive);
			});

			currentButton.classList.add(classes.active);
			currentButton.classList.remove(classes.inactive);
		}
	}

	if (!customElements.get('form-toggle')) {
		customElements.define('form-toggle', FormToggle);
	}
}
